module.exports = ".logo {\n  max-width: 140px;\n  min-width: 100px;\n  position: relative;\n  padding-bottom: 20px; }\n"